export default "__VITE_ASSET__D0XCg35T__"